import React from 'react'
import classNames from 'classnames'
import './Card.scss'
import { ThemeColours, ThemeSpacing } from '../../../types/theme'

interface CardProps extends React.HTMLProps<HTMLDivElement> {
  children: React.ReactNode
  className?: string
  flex?: boolean
  error?: boolean
  wide?: boolean
  borderColour?: ThemeColours
  sharp?: boolean
  transparent?: boolean
  padding?: ThemeSpacing
}

const Card = React.forwardRef<HTMLDivElement, CardProps>(({ className, children, error, flex, wide, borderColour, sharp, transparent, padding = 4, ...rest }, ref) => {
  const borderColourClass = borderColour ? `borderColor-${borderColour}` : null
  return (
    <div
      ref={ref}
      className={classNames(`card p-${padding}`, className, {
        flex,
        error,
        wide,
        sharp,
        transparent
      }, borderColourClass)}
      {...rest}
    >
      {children}
    </div>
  )
})

export default Card
